// extracted by mini-css-extract-plugin
export var attachButton = "_kk-8";
export var sendButton = "_kk-2";
export var sendDisabled = "_kk-4";
export var sendEnabled = "_kk-3";
export var sendIcon = "_kk-6";
export var sendIconDisabled = "_kk-7";
export var sendStreaming = "_kk-5";
export var textarea = "_kk-1";
export var wrapper = "_kk-0";